export default "__VITE_ASSET__DJrVHKIV__"